var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickAfter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11204_10455)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11204_10455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C10.0166 0 8.5666 0.439867 7.33323 1.26398C6.09986 2.08809 5.13856 3.25943 4.57091 4.62987C4.00325 6.00032 3.85472 7.50832 4.14411 8.96318C4.4335 10.418 5.14781 11.7544 6.1967 12.8033C7.2456 13.8522 8.58197 14.5665 10.0368 14.8559C11.4917 15.1453 12.9997 14.9968 14.3701 14.4291C15.7406 13.8614 16.9119 12.9001 17.736 11.6668C18.5601 10.4334 19 8.98336 19 7.5C19 5.51088 18.2098 3.60322 16.8033 2.1967C15.3968 0.790176 13.4891 0 11.5 0Z",
    fill: "#005068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3409 5.42678L10.5199 10.2695C10.4094 10.3846 10.2604 10.455 10.1014 10.4675C9.93946 10.4559 9.78824 10.3823 9.67914 10.262L7.65639 8.24303C7.64274 8.22963 7.6319 8.21364 7.6245 8.196C7.61709 8.17836 7.61328 8.15942 7.61328 8.14028C7.61328 8.12115 7.61709 8.10221 7.6245 8.08457C7.6319 8.06693 7.64274 8.05094 7.65639 8.03753L8.29839 7.39553C8.31142 7.3819 8.32707 7.37104 8.34441 7.36363C8.36175 7.35621 8.38041 7.35239 8.39927 7.35239C8.41813 7.35239 8.43679 7.35621 8.45413 7.36363C8.47146 7.37104 8.48712 7.3819 8.50014 7.39553L10.1014 8.99678L14.5001 4.56503C14.5133 4.55142 14.529 4.54057 14.5464 4.5331C14.5638 4.52563 14.5825 4.5217 14.6014 4.52153C14.6204 4.52101 14.6393 4.52463 14.6568 4.53214C14.6743 4.53965 14.6899 4.55088 14.7026 4.56503L15.3334 5.21753C15.3483 5.23035 15.3604 5.24612 15.3689 5.26384C15.3775 5.28156 15.3822 5.30086 15.3829 5.32052C15.3836 5.34017 15.3803 5.35976 15.373 5.37805C15.3658 5.39634 15.3549 5.41293 15.3409 5.42678Z",
    fill: "#DADADA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11204_10455",
    x: 0,
    y: 0,
    width: 23,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11204_10455"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11204_10455",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11204_10455"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickAfter);
export default __webpack_public_path__ + "static/media/TickAfter.0b88dc9f9dab806fec706c1ac146fefd.svg";
export { ForwardRef as ReactComponent };